import { ReactNode } from "react";
import ConfirmModal from "../../ConfirmModal";
import { dangerFilledBtn } from "../../../styles";

interface Props {
  title: string;
  message: string;
  /** Impact preview shown between the message and the action buttons — e.g. row
   *  counts or affected leagues, for actions whose blast radius isn't obvious. */
  impact?: ReactNode;
  /** Stronger visual treatment for an action with no undo (vs. a merely
   *  destructive-but-recoverable one — ConfirmModal's default `danger` styling). */
  irreversible?: boolean;
  confirmLabel?: string;
  confirming?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDestructive({
  title,
  message,
  impact,
  irreversible = false,
  confirmLabel,
  confirming = false,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <ConfirmModal
      title={title}
      message={message}
      confirmLabel={confirmLabel}
      danger
      confirmButtonStyle={irreversible ? dangerFilledBtn : undefined}
      confirming={confirming}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      {impact && (
        <div style={{
          background: "var(--color-surface-raised)",
          border: "1px solid var(--color-border-subtle)",
          borderRadius: 8,
          padding: "0.75rem 1rem",
          fontSize: "0.85rem",
          color: "var(--color-text)",
        }}>
          {impact}
        </div>
      )}
    </ConfirmModal>
  );
}
